import { render } from "./aboutMshelHomes.vue?vue&type=template&id=16d0ba68"
import script from "./aboutMshelHomes.vue?vue&type=script&lang=js"
export * from "./aboutMshelHomes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__